.SourceCard {
    min-width: 0;

    & svg {
        flex-shrink: 0;
        opacity: 0.65;
    }
}

.SourceCard__body {
    min-width: 0;
    overflow-wrap: anywhere;
}
